import { useAppSelector } from "app/redux/hooks";
import { Documento } from "app/types/cliente/RespostaDocumentosAbertos";
import { Dict } from "app/utils/Dict";
import React, { useEffect, useRef } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { DocumentosAbertosInformacoes } from "./DocumentosAbertosInformacoes";

export type DocumentosAbertosInformacoesContainerProps = {
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover: () => boolean
    documento: Documento;
};

export const DocumentosAbertosInformacoesContainer = (props: DocumentosAbertosInformacoesContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento);

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => {
        passosInterno.current.set("Detalhes Documentos Abertos", () => { })
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
                id="DocumentosAbertosInformacoesBreadcrumb"
            />
            
            <DocumentosAbertosInformacoes
                documentosAbertosInformacoes={props.documento}
                cpfcnpj={orcamento.Cliente.CpfCnpj}
                nome={orcamento.Cliente.Nome}
            />
        </>

    )
}